module.exports = __webpack_public_path__ + "img/photo2.07a63621.jpg";